/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum Pronouns {
  HeHim = "HeHim",
  SheHer = "SheHer",
  TheyThem = "TheyThem",
}

export const PronounsDisplay: Record<Pronouns, string> = {
  [Pronouns.HeHim]: "He Him",
  [Pronouns.SheHer]: "She Her",
  [Pronouns.TheyThem]: "They Them",
};
